import { api } from './api';
import type { Page, PageTreeNode, PageFormData, PageReorderItem } from '../types/pages';

export const pagesApi = {
  // List all pages
  async listPages() {
    const response = await api.get<{ results: Page[]; count: number }>('/api/pages/');
    return response.data;
  },

  // Get single page
  async getPage(id: string) {
    const response = await api.get<Page>(`/api/pages/${id}/`);
    return response.data;
  },

  // Get page tree structure
  async getTree() {
    const response = await api.get<PageTreeNode[]>('/api/pages/tree/');
    return response.data;
  },

  // Create new page
  async createPage(data: PageFormData) {
    const response = await api.post<Page>('/api/pages/', data);
    return response.data;
  },

  // Update page
  async updatePage(id: string, data: Partial<PageFormData>) {
    const response = await api.patch<Page>(`/api/pages/${id}/`, data);
    return response.data;
  },

  // Delete page
  async deletePage(id: string) {
    await api.delete(`/api/pages/${id}/`);
  },

  // Reorder pages
  async reorderPages(items: PageReorderItem[]) {
    const response = await api.post('/api/pages/reorder/', items);
    return response.data;
  },

  // Duplicate page
  async duplicatePage(id: string) {
    const response = await api.post<Page>(`/api/pages/${id}/duplicate/`, {});
    return response.data;
  },
};